import _ from 'lodash';
import { DisplayData } from 'mui-datatables';
import { SelectedRows } from './ListTypes';

export const findSelectedIds = (selectedRows: SelectedRows, displayData: DisplayData): string[] => {
  return selectedRows.data.map((row) => _.find(displayData, (data) => data.dataIndex === row.dataIndex)?.data[0]);
};
